import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import AppProviders from '@/components/Providers/AppProviders'
import AppRouter from '@/routes'
import { reportError, startWebVitals } from '@/observability'
import { validateProductionEnv } from '@/bootstrap/validateProductionEnv'
import './scss/index.scss'

validateProductionEnv()

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    reportError(event.error ?? event.message, { source: 'window-error' })
  })
  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason, { source: 'unhandled-rejection' })
  })

  startWebVitals((sample) => {
    if (import.meta.env.DEV) {
      console.debug('[web-vitals]', sample)
    }
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
)
